module.exports = Promise.all([__parcel__import__("ghDyT"), __parcel__import__("aghaw")]).then(() => parcelRequire('3pHq1'));